<template>
    <span class="inline-flex items-center gap-1 rounded-full px-2 py-1 text-sm font-medium"
          :class="badgeClasses">
        <span v-html="iconSvg" class="inline-flex items-center"></span>
        <span>{{ badgeText }}</span>
    </span>
</template>

<script>
export default {
    name: 'AlarmStatusBadge',
    props: {
        status: {
            type: String,
            required: true,
            validator: (value) => ['active', 'snoozed', 'resolved'].includes(value)
        }
    },
    computed: {
        badgeClasses() {
            const classes = {
                active: 'bg-red-100 text-red-800',
                snoozed: 'bg-amber-100 text-amber-800',
                resolved: 'bg-green-100 text-green-800'
            };
            return classes[this.status] || '';
        },
        iconSvg() {
            const icons = {
                active: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" /><path d="M9 17v1a3 3 0 0 0 6 0v-1" /><path d="M21 6.727a11.05 11.05 0 0 0 -2.794 -3.727" /><path d="M3 6.727a11.05 11.05 0 0 1 2.792 -3.727" /></svg>',
                snoozed: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 12h6l-6 8h6" /><path d="M14 4h6l-5.146 6.862m1.146 1.138h4" /><path d="M3 3l18 18" /></svg>',
                resolved: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-check"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l5 5l10 -10" /></svg>'
            };
            return icons[this.status] || '';
        },
        badgeText() {
            const labels = {
                active: 'Active',
                snoozed: 'Snoozed',
                resolved: 'Resolved'
            };
            return labels[this.status] || this.status;
        }
    }
};
</script>
